import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DanhMucQuocGiaDto, DanhMucQuocGiaClient } from '../../api-connector/sso-connector';
import { BaseAutocompleteControl } from '../base-autocomplete-control';
import { AutocompleteCacheService } from '../../services/autocomplete-cache.service';

@Component({
  selector: 'ac-quoc-gia-control',
  templateUrl: './ac-quoc-gia-control.component.html',
  styleUrls: ['./ac-quoc-gia-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AcQuocGiaControlComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AcQuocGiaControlComponent),
      multi: true,
    }
  ]
})
export class AcQuocGiaControlComponent extends BaseAutocompleteControl<DanhMucQuocGiaDto> implements OnInit {

  constructor(
    private danhMucQuocGiaClient: DanhMucQuocGiaClient,
    private autocompleteCache: AutocompleteCacheService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  protected fetchItems(searchValue: string): Observable<DanhMucQuocGiaDto[]> {
    return this.autocompleteCache.wrap(`quoc_gia_${searchValue}`,
      this.danhMucQuocGiaClient.getDanhMucQuocGiaByKeySearch(searchValue).pipe(
        map(items => items || [])
      )
    );
  }

  getDisplayValue(item: DanhMucQuocGiaDto | null): string {
    return item?.tenQuocGia || '';
  }

  protected isValidItem(value: any): boolean {
    return value instanceof DanhMucQuocGiaDto;
  }
}
